// Mirrors lead.models.LeadStatus. Used by the lead itself and by every
// activity logged on it, so an activity's status can be copied onto the lead.
export const LEAD_STATUS_OPTIONS = [
  { value: 'PENDING', label: 'Pending', color: 'default' },
  { value: 'CONTACTED', label: 'Contacted', color: 'blue' },
  { value: 'COLD', label: 'Cold', color: 'cyan' },
  { value: 'WARM', label: 'Warm', color: 'orange' },
  { value: 'HOT', label: 'Hot', color: 'red' },
  { value: 'CONVERTED', label: 'Converted', color: 'green' },
  { value: 'NOT_INTERESTED', label: 'Not Interested', color: 'volcano' },
  { value: 'NOT_RELEVANT', label: 'Not Relevant', color: 'purple' },
];

// Legacy DEAD is no longer offered but may still be on old records.
export const leadStatusMeta = (value) =>
  LEAD_STATUS_OPTIONS.find((option) => option.value === value)
  || { value, label: value === 'DEAD' ? 'Dead' : value, color: 'default' };
